export function countryCodeToFlagEmoji(cc?: string) {
    return cc?.toUpperCase().replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + 127397)) || '';
}
